
  import { composeConfigs, PreviewWeb, ClientApi } from '@storybook/preview-api';

  // generateAddonSetupCode
  import { createBrowserChannel } from '@storybook/channels';
  import { addons } from '@storybook/preview-api';

  const channel = createBrowserChannel({ page: 'preview' });
  addons.setChannel(channel);
  window.__STORYBOOK_ADDONS_CHANNEL__ = channel;

  const importers = {
      ...import("story:Li4vLi4vLi4vLnN0b3J5Ym9vay1zMi9kb2NzLyoubWR4"),
...import("story:Li4vLi4vLi4vcGFja2FnZXMvQHJlYWN0LXNwZWN0cnVtL3MyL3N0b3JpZXMvKi5zdG9yaWVzLkAoanN8anN4fG1qc3x0c3x0c3gp")
    };

    async function importFn(path) {
      return importers[path]();
    }

  const getProjectAnnotations = async () => {
    const configs = await Promise.all([import('@storybook/react/dist/entry-preview.mjs'),
import('@storybook/react/dist/entry-preview-docs.mjs'),
import('@storybook/addon-links/preview'),
import('@storybook/addon-essentials/docs/preview'),
import('@storybook/addon-essentials/actions/preview'),
import('@storybook/addon-essentials/backgrounds/preview'),
import('@storybook/addon-essentials/measure/preview'),
import('@storybook/addon-essentials/outline/preview'),
import('@storybook/addon-essentials/highlight/preview'),
import('@storybook/addon-interactions/preview'),
import('@storybook/addon-a11y/preview'),
import('../../../.storybook-s2/preview.tsx')])
    return composeConfigs(configs);
  }

  if (!window.__STORYBOOK_PREVIEW__) {
    const preview = new PreviewWeb();

    window.__STORYBOOK_PREVIEW__ = preview;
    window.__STORYBOOK_STORY_STORE__ = preview.storyStore;
    window.__STORYBOOK_CLIENT_API__ = new ClientApi({ storyStore: preview.storyStore });

    preview.initialize({ importFn, getProjectAnnotations });
  }

  module.hot.accept(() => {
    // importFn has changed so we need to patch the new one in
    window.__STORYBOOK_PREVIEW__.onStoriesChanged({ importFn });

    // getProjectAnnotations has changed so we need to patch the new one in
    window.__STORYBOOK_PREVIEW__.onGetProjectAnnotationsChanged({ getProjectAnnotations });
  });
 